import type {
  ClosureStatus,
  SubscriptionRecordStatus,
} from 'src/pages/admin/services/vaultService';

import { ALL_VAULTS_VALUE } from '../vaults/constants';

export const RECORDS_PERMISSION_RESOURCE = 'vault:records';

export const RECORDS_NS = 'module.vaultRecords';

/** PRD §14.6's two tabs; each is its own URL (`/vault/records/:tab`). */
export const RECORD_TABS = ['subscriptions', 'redemptions'] as const;
export type RecordTab = (typeof RECORD_TABS)[number];
export const DEFAULT_TAB: RecordTab = 'subscriptions';

/** C-06 `SubscriptionRecordStatus`, in schema order; the engine stays the authority. */
export const SUBSCRIPTION_RECORD_STATUSES: readonly SubscriptionRecordStatus[] = [
  'SUBSCRIBED',
  'REJECTED',
];

/** C-06 `ClosureStatus` (the client's C-03 enum), in schema order. */
export const CLOSURE_STATUSES: readonly ClosureStatus[] = [
  'ISSUED',
  'CLOSING',
  'EXECUTED',
  'ROLLED_BACK',
  'ESCALATED',
];

/**
 * The C-03 `ActionBlocker` codes the runner records on a rejection. PRD §14.6 names two ("in lock-up", "over cap");
 * the other four read with neutral words until the PO names them. A code added later shows raw, never a crash.
 */
export const REJECTION_BLOCKERS = [
  'WITHIN_LOCKUP',
  'ABOVE_SIZE_CAP',
  'BELOW_MINIMUM',
  'TERMS_NOT_ACCEPTED',
  'SUBSCRIPTIONS_PAUSED',
  'VAULT_NOT_ACTIVE',
] as const;

/** Page sizes the console offers; every one is within the engine's 1–200. */
export const ROWS_PER_PAGE_OPTIONS = [20, 50, 100];
export const DEFAULT_ROWS_PER_PAGE = 50;

/** The `vault` query value that means every vault (no vault filter): the switcher's own sentinel. */
export const ALL_VAULTS = ALL_VAULTS_VALUE;

/** The BFF's 422 when the engine refuses the range (from after to, or a time it cannot read). */
export const VAULT_FILTER_INVALID = 'VAULT_FILTER_INVALID';
